import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
export default {
  name: "About",
  metaInfo: function metaInfo() {
    return {
      title: "清北博雅-关于我们",
      meta: [{
        name: "description",
        content: "一站式在线教育方案，满足教育机构网上教学功能需求"
      }, {
        name: "keywords",
        content: "直播,录播,考试测评,题库,营销工具,教务管理"
      }]
    };
  },
  data: function data() {
    return {
      info: ""
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var info, div;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/config/about_us");

            case 2:
              info = _context.sent;
              div = document.createElement("div");
              div.innerHTML = info.about_us.about_us;
              div.querySelectorAll("img").forEach(function (el) {
                el.removeAttribute("title");
              });
              this.info = div.innerHTML;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    window.$(window).scrollTop(0);
  },
  methods: {}
};